import React, { Component } from 'react'
import {Recorder} from 'react-voice-recorder'
import 'react-voice-recorder/dist/index.css'
 
export default class RecorderBox extends Component {
  constructor(props) {
    super(props)
 
    this.state = {
      audioDetails: {
        url: null,
        blob: null,
        chunks: null,
        duration: {
          h: 0,
          m: 0,
          s: 0
        }
      },
      boxId: -1
    }
    this.handleAudioStop.bind(this)
  }
 
  handleAudioStop(data){
    var reader = new FileReader();
    reader.readAsDataURL(data.blob); 
    const _this = this;
    reader.onloadend = function() {
        var base64data = reader.result;
        _this.props.file64(base64data);
    }
    this.setState({ audioDetails: data });
}
handleReset() {
    const reset = {
      url: null,
      blob: null,
      chunks: null,
      duration: {
        h: 0,
        m: 0,
        s: 0
      }
    };
    this.setState({ audioDetails: reset });
  }
  componentDidUpdate(){ // animation stuffs:
    if(this.state.boxId !== this.props.boxId){
      if(document.querySelector(".recorder")){
        if(this.props.boxId > -1){
            document.querySelector(".recorder-con").classList.add("show");
            setTimeout(()=>{
                document.querySelector(".recorder").classList.add("show");
                document.querySelector(".recorder-con").classList.remove("fade");
            }, 5);
        }else{
            document.querySelector(".recorder").classList.remove("show");
            document.querySelector(".recorder-con").classList.add("fade");
            setTimeout(()=>{
                document.querySelector(".recorder-con").classList.remove("show");
            }, 300);
        }
      }
      this.setState({boxId: this.props.boxId})
      if(this.props.boxId === -1){
        this.handleReset();
      }
    }
  }
  render() {
    return (
      <div className="recorder-con" onClick={()=>this.props.close()}>
        <div className="recorder" onClick={(e)=>e.stopPropagation()}>
          
          <Recorder
              record={this.props.boxId > -1}
              title={"New recording"}
              audioURL={this.state.audioDetails.url}
              handleAudioStop={data => this.handleAudioStop(data)}
              handleAudioUpload={data => this.handleAudioUpload(data)}
              handleReset={() => this.handleReset()}
              mimeTypeToUseWhenRecording={`audio/webm`} // For specific mimetype.
              showUIAudio={false}
              hideHeader 
              key={this.props.boxId}
          />
        </div>
      </div>
    )
  }
}